import { createRouter, createWebHashHistory } from 'vue-router'
import { useUserStore } from '@/store'

const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { public: true }
  },
  {
    path: '/',
    name: 'Layout',
    component: () => import('@/layout/index.vue'),
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: { title: '工作台', icon: 'HomeFilled' }
      },
      // 客户管理
      {
        path: 'customer/list',
        name: 'CustomerList',
        component: () => import('@/views/customer/list.vue'),
        meta: { title: '客户列表', icon: 'UserFilled' }
      },
      {
        path: 'customer/pool',
        name: 'CustomerPool',
        component: () => import('@/views/customer/pool.vue'),
        meta: { title: '公海客户', icon: 'Watermelon' }
      },
      {
        path: 'customer/contacts',
        name: 'Contacts',
        component: () => import('@/views/customer/contacts.vue'),
        meta: { title: '联系人', icon: 'User' }
      },
      {
        path: 'customer/detail/:id',
        name: 'CustomerDetail',
        component: () => import('@/views/customer/detail.vue'),
        meta: { title: '客户详情', hidden: true }
      },
      // 销售管理
      {
        path: 'sales/opportunities',
        name: 'Opportunities',
        component: () => import('@/views/sales/opportunities.vue'),
        meta: { title: '商机管理', icon: 'Opportunity' }
      },
      {
        path: 'sales/follows',
        name: 'Follows',
        component: () => import('@/views/sales/follows.vue'),
        meta: { title: '跟进记录', icon: 'Edit' }
      },
      {
        path: 'sales/quotes',
        name: 'Quotes',
        component: () => import('@/views/sales/quotes.vue'),
        meta: { title: '报价管理', icon: 'Document' }
      },
      {
        path: 'sales/contracts',
        name: 'Contracts',
        component: () => import('@/views/sales/contracts.vue'),
        meta: { title: '合同管理', icon: 'DocumentChecked' }
      },
      {
        path: 'sales/targets',
        name: 'Targets',
        component: () => import('@/views/sales/targets.vue'),
        meta: { title: '销售目标', icon: 'Aim' }
      },
      // 产品管理
      {
        path: 'product/list',
        name: 'ProductList',
        component: () => import('@/views/product/list.vue'),
        meta: { title: '产品列表', icon: 'GoodsFilled' }
      },
      {
        path: 'product/categories',
        name: 'Categories',
        component: () => import('@/views/product/categories.vue'),
        meta: { title: '产品分类', icon: 'Folder' }
      },
      // 数据统计
      {
        path: 'report/funnel',
        name: 'Funnel',
        component: () => import('@/views/report/funnel.vue'),
        meta: { title: '销售漏斗', icon: 'PieChart' }
      },
      {
        path: 'report/performance',
        name: 'Performance',
        component: () => import('@/views/report/performance.vue'),
        meta: { title: '业绩统计', icon: 'Histogram' }
      },
      {
        path: 'report/forecast',
        name: 'Forecast',
        component: () => import('@/views/report/forecast.vue'),
        meta: { title: '业绩预测', icon: 'TrendCharts' }
      },
      {
        path: 'report/customer-analysis',
        name: 'CustomerAnalysis',
        component: () => import('@/views/report/customer_analysis.vue'),
        meta: { title: '客户分析', icon: 'DataAnalysis' }
      },
      {
        path: 'report/product-sales',
        name: 'ProductSales',
        component: () => import('@/views/report/product_sales.vue'),
        meta: { title: '产品销售', icon: 'ShoppingCart' }
      },
      // 系统管理
      {
        path: 'system/users',
        name: 'Users',
        component: () => import('@/views/system/users.vue'),
        meta: { title: '用户管理', icon: 'UserFilled' }
      },
      {
        path: 'system/depts',
        name: 'Depts',
        component: () => import('@/views/system/depts.vue'),
        meta: { title: '部门管理', icon: 'OfficeBuilding' }
      },
      {
        path: 'system/roles',
        name: 'Roles',
        component: () => import('@/views/system/roles.vue'),
        meta: { title: '角色管理', icon: 'Key' }
      },
      {
        path: 'system/menus',
        name: 'Menus',
        component: () => import('@/views/system/menus.vue'),
        meta: { title: '菜单管理', icon: 'Menu' }
      },
      {
        path: 'system/operation-logs',
        name: 'OperationLogs',
        component: () => import('@/views/system/operation_logs.vue'),
        meta: { title: '操作日志', icon: 'Tickets' }
      },
      {
        path: 'system/login-logs',
        name: 'LoginLogs',
        component: () => import('@/views/system/login_logs.vue'),
        meta: { title: '登录日志', icon: 'Clock' }
      },
      {
        path: 'system/dicts',
        name: 'Dicts',
        component: () => import('@/views/system/dicts.vue'),
        meta: { title: '字典管理', icon: 'Collection' }
      },
      {
        path: 'notifications',
        name: 'Notifications',
        component: () => import('@/views/system/notifications.vue'),
        meta: { title: '通知中心', icon: 'Bell' }
      },
      {
        path: 'profile',
        name: 'Profile',
        component: () => import('@/views/system/profile.vue'),
        meta: { title: '个人中心', hidden: true }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const userStore = useUserStore()
  
  if (to.meta?.public) {
    next()
    return
  }
  
  if (!userStore.token) {
    next('/login')
    return
  }
  
  next()
})

export default router
